import { Button } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { IS_DEV } from "../../../variables";

export interface ErrorComponentProps {
	error: Error;
}

const ErrorComponent: React.FC<ErrorComponentProps> = ({ error }) => {
	console.error(error);

	const { t } = useTranslation();

	return (
		<div id="error-page">
			<h1>{t("error.general.header")}</h1>
			<p>{t("error.general.body")}</p>
			<p>
				<i>{error?.message}</i>
			</p>
			{IS_DEV && error.stack && <code>{error.stack}</code>}
			<div>
				<Link to="/">
					<Button>{t("error.404.btnGoHome")}</Button>
				</Link>
			</div>
		</div>
	);
};

export default ErrorComponent;
